import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { addToast, toastMessageTypes } from "@/redux/actions/toaster";
import { NPSRating, NPSScoreReason } from "@/component-library";
import { surveyRequests } from "@/api/(requests)/survey";

import { useCheckNPS } from "./useCheckNPS";

import "./styles.scss";

const SURVEY_TYPE = "nps_updated_calendar";

export const NPSUpdatedCalendar = () => {
  const dispatch = useDispatch();
  const { recordAnswer, shouldShowNPS } = useCheckNPS(SURVEY_TYPE);
  const [npsKey, setNPSKey] = useState();

  const finishLastQuestion = () => {
    recordAnswer();
    setNPSKey(undefined);
    dispatch(
      addToast({
        message: "Thank you for your feedback.",
        messageType: toastMessageTypes.success_v2,
      }),
    );
  };

  if (!shouldShowNPS) {
    return null;
  }

  return (
    <div className="NPSUpdatedCalendar">
      {!npsKey && (
        <NPSRating
          dismissHandler={async () => {
            await surveyRequests.submit_survey({
              data: {
                survey_type: SURVEY_TYPE,
              },
            });
            recordAnswer();
          }}
          featureArea="scheduling"
          submitHandler={async (event) => {
            const score = Number(event.target.value);
            const response = await surveyRequests.submit_survey({
              data: {
                score,
                survey_type: SURVEY_TYPE,
              },
            });

            setNPSKey(response?.key);
          }}
        />
      )}

      {npsKey && (
        <NPSScoreReason
          dismissHandler={finishLastQuestion}
          submitHandler={async (scoreReason) => {
            if (!scoreReason) {
              finishLastQuestion();

              return;
            }

            await surveyRequests.submit_survey({
              data: {
                key: npsKey,
                score_reason: scoreReason,
                survey_type: SURVEY_TYPE,
              },
            });

            finishLastQuestion();
          }}
        />
      )}
    </div>
  );
};
